import React, { useState } from 'react';
import System from '../../basic/System';
import ViewUtil from '../../ViewUtil';
import Setting from './Setting';
import './settingsTab.css';
import ToolTip from '../../common/AssetPropertyView';
import TooltipProperties from '../../common/TooltipProperties';
import LogManagementModal from '../../modals/settings/LogManagementModal';

const SettingsTab = () => {
  const [closeModal, setCloseModal] = useState(null);
  const settingOptions = [
    {
      title: 'Profile',
      description: 'Change your profile image and password',
      img: 'images/profileSetting.svg'
    },
    {
      title: 'Application',
      description: 'Change general setting of application',
      img: 'images/accountSetting.svg'
    }
    // {
    //   title: 'Notifications',
    //   description: 'Change notifications settings',
    //   img: 'images/notificationSetting.svg'
    // }
  ];

  if (System.isDesktop()) {
    settingOptions.push(
      {
        title: 'Log Management',
        description: 'Choose the type and its file to download logs',
        img: 'images/LogManagement.svg'
      },
      {
        title: 'Evolphin Media Store Drives',
        description: 'Manage Evolphin Media Store Drives',
        img: 'images/cloud-database.svg'
      });
  }

  if (window.ARGS.currentSetting) {
    return <Setting currentSetting={window.ARGS.currentSetting} />;
  } else {
    return (
      <div name="SettingsTab">
        {closeModal === 'LOG_MANAGEMENT' ? (<LogManagementModal onClose={() => setCloseModal(null)} />) : null}
        <div className="tab-title">Settings</div>
        <div className="settings">
          {settingOptions.map((settings) => {
            if (settings.title === "Log Management") {
              return (
                < div key={settings.title} className="setting" onClick={() => setCloseModal('LOG_MANAGEMENT')}>
                  <div className="img">
                    <img src={settings.img} />
                  </div>
                  <div className="setting-title">{settings.title}</div>
                  <div className="setting-description">{settings.description}</div>
                </div>
              )
            }
            return (
              <div key={settings.title} className="setting" onClick={() => ViewUtil.switchToSetting(settings.title)}>
                <div className="img">
                <ToolTip text={TooltipProperties[settings.title]}>
                  <img src={settings.img} style={{ height: '50px', width: '50px' }} />
                  </ToolTip>
                </div>
                <ToolTip text={TooltipProperties[settings.title]}>
                <div className="setting-title">{settings.title}</div>
                </ToolTip>
                <div className="setting-description">{settings.description}</div>
              </div>
            );
          })}
        </div>
      </div >
    );
  }
};
export default SettingsTab;
